import { connect } from 'react-redux';
import * as Action from '../../../actions/AdminCompanyManagement';
import DialogEditCompany from '../../../pages/Admin/CompanyManagement/DialogEditCompany';
import DetailCompanySelector from '../../../selectors/AdminCompanyManagement';
import { callApiGetInformationRoom } from '../../../actions/RegistrationOrganizer';
import { GetJobsRequested, GetCategoryRequest, GetOccupationRequest, ClearOccupation } from '../../../actions/CommonOptions';

const createDetailCompanySelector = DetailCompanySelector.createDetailCompanySelector();

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
    companyDetail: createDetailCompanySelector(state),
    room: state.registrationOrganizer.registrationOrganizer.room,
    errorEdit: state.adminCompanyManagement.editCompany.errors,
    deleteSuccess: state.adminCompanyManagement.deleteCompany.deleteSuccess,
    errorDeleteCompany: state.adminCompanyManagement.deleteCompany.errors,
    eventInfo: state.eventManagement.infoEvent.data,
    options: state.commonOptions.Options.data,
    jobs: state.commonOptions.jobs.data,
    zones: state.commonOptions.zones.data,
    eventStartDate: state.eventManagement.infoEvent.data.sdate,
    eventEndDate: state.eventManagement.infoEvent.data.edate,
    occupations: state.commonOptions.occupations.data,
    category: state.commonOptions.category.data,
});

const mapDispatchToProps = (dispatch) => ({
    fetchEditCompany: (params) => dispatch(Action.EditCompanyRequested(params)),
    fetchClearEditCompany: () => dispatch(Action.ClearEditCompany()),
    fetchDeleteCompany: (params) => dispatch(Action.DeleteCompanyRequested(params)),
    clearDeleteCompany: () => dispatch(Action.ClearDeleteCompany()),
    getInformationRoom: (locale) => {
        dispatch(callApiGetInformationRoom(locale));
    },
    fetchJobs: (eventName) => {
        dispatch(GetJobsRequested(eventName));
    },
    fetchCategory: (eventName) => {
        dispatch(GetCategoryRequest(eventName));
    },
    getOccupations: (param) => {
        dispatch(GetOccupationRequest(param));
    },
    clearOccupations: () => {
        dispatch(ClearOccupation());
    },
});
export default connect(mapStateToProps, mapDispatchToProps)(DialogEditCompany);
